// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

// import Vuex store
import store from "./store";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { SnackbarPlugin } from "./components/snackbar/snackbar.js";
import { onboardingService } from "@/services/OnboardingService";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
window.onboarding = onboardingService; // make it globally accessible for debugging

Vue.use(SnackbarPlugin);

Vue.config.productionTip = false;
onboardingService.init(store);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js